import { ClockFadingIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { BaseError } from './BaseError'

const Unauthorized = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <BaseError
      title="Your session has expired"
      description="You will be logged out and redirected to the login page shortly. If you are not automatically redirected, please click the button below."
      icon={ClockFadingIcon}
      withLogout
      {...props}
      ref={ref}
    />
  )
})

Unauthorized.displayName = 'Unauthorized'

export { Unauthorized }
